/**
 * MSW Override: Booking Payment 3DS Timeout scenario
 *
 * Same round-trip as booking-payment-3ds-challenge, but once the return notification
 * has been posted the booking settles as DRAFT/UNPAID with a FAILED block whose
 * failureReason is CHALLENGE_TIMEOUT: the wait expired with the challenge unfinished
 * (no provider error code beside it).
 *
 * Enable by setting ENABLE_MSW=true and
 * NUXT_PUBLIC_MSW_OVERRIDES_BOOKING_PAYMENT_3DS_TIMEOUT=true in your .env,
 * then restart the dev server.
 */

import type { HttpHandler } from 'msw';
import { createMockBookingResponse, createMockPaymentAuthenticationResponse } from '@cvo/domain';
import { DDC_COLLECTED_PROVIDER_DATA, createChallengeRoundTripOverrides } from './booking-payment-3ds-challenge';

export function createBookingPayment3dsTimeoutOverrides(baseUrl: string): HttpHandler[] {
  return createChallengeRoundTripOverrides('booking payment 3ds timeout', baseUrl, bookingId =>
    createMockBookingResponse({
      id: bookingId,
      bookingStatus: 'DRAFT',
      paymentStatus: 'UNPAID',
      paymentAuthentication: createMockPaymentAuthenticationResponse({
        status: 'FAILED',
        failureReason: 'CHALLENGE_TIMEOUT',
        providerData: DDC_COLLECTED_PROVIDER_DATA,
      }),
    }));
}
